import { T } from "@/locales";

export default [
  {
    title: T("序号"),
    dataIndex: "index",
    key: "index",
    customRender: (value, item, index) => {
      return index + 1;
    },
  },
  {
    title: T("单位名称"),
    dataIndex: "name",
    sorter: true,
  },
  {
    title: T("备注"),
    dataIndex: "remark",
  },
  {
    title: T("操作"),
    dataIndex: "action",
    scopedSlots: { customRender: "action" },
    width: "156px",
  },
];
